<template>
  <div class="order-details">
    <div class="table-main">
      <div class="table-header fn-clear">
        <div class="fn-left">
          <el-button type="success" @click="exportExcel">导出Excel表</el-button>
        </div>
        <div class="fn-right table-header-right">
          <el-pagination
            :current-page.sync="p"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="limit"
            layout="sizes, prev, slot, next"
            prev-text="上一页"
            next-text="下一页"
            :total="itemTotal"
            @size-change="handleSizeChange"
          >
            <div class="chax">
              {{ p }}/{{ itemTotal > 0 ? Math.ceil(itemTotal / limit) : 1 }}
            </div>
          </el-pagination>
        </div>
      </div>
      <div class="table-body">
        <el-table
          :data="showList"
          border
          stripe
          :header-cell-style="{
            background: '#4c84ff',
            color: '#fff',
            height: '60px',
            textAlign: 'center'
          }"
        >
          <el-table-column
            prop="order_id"
            label="订单编号"
            align="center"
          />
           <el-table-column
            prop="contract_amount"
            label="合同金额"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.contract_amount/100 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="is_finish"
            label="订单状态"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.is_finish == 0
                    ? 'green-font-color'
                    : scope.row.is_finish == 2
                      ? 'danger-font-color'
                      : ''
                "
              >{{
                scope.row.is_finish == 0
                  ? "进行中"
                  : scope.row.is_finish == 2
                    ? "已退款"
                    : "已完成"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="kpi_status_name"
            label="订单类型"
            align="center"
          />
          <el-table-column
            prop="item_title"
            label="套餐名称"
            align="center"
          />
          <el-table-column prop="detail" label="套餐详情" width="320">
            <template slot-scope="scope">
              <p v-for="(item, index) in scope.row.detail" :key="index">
                {{ item.text }} - 日耗金额: {{ item.price/100 }}
              </p>
            </template>
          </el-table-column>
          <el-table-column
            prop="editor_name"
            label="签单人"
            align="center"
          />
          <el-table-column
            prop="modify_time"
            label="最后操作时间"
            align="center"
          />
          <el-table-column
            prop="remark"
            label="备注"
            align="center"
          />
        </el-table>
      </div>
      <div class="pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="p"
            prev-text="上一页"
            next-text="下一页"
            :total="itemTotal"
            :page-size="limit"
          >
            <div class="chax">
              {{ p }}/{{ itemTotal > 0 ? Math.ceil(itemTotal / limit) : 1 }}
            </div>
          </el-pagination>
          <div class="insert">
            <el-button type="primary">确定</el-button>
            <span class="pagination-count">
              符合查询结果:
              <i>{{ itemTotal }}条</i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tool from '@/assets/js/tool.js'
export default {
  name: 'OrderDetails',
  components: {},
  data() {
    return {
      itemList: [],
      showList: [],
      limit: 10,
      p: 1,
      itemTotal: 0
    }
  },
  watch: {
    p() {
      this.showList = this.itemList.slice(
        (this.p - 1) * this.limit,
        (this.p - 1) * this.limit + this.limit
      )
    }
  },
  mounted() {
    const child_id = this.$route.query.child_id
    this.getInfoOrder(child_id)
  },
  methods: {
    async getInfoOrder(child_id) {
      const ret = await this.$http.getInfoOrder({ child_id })
      if (ret.code == 200) {
        this.itemTotal = ret.data.length
        this.itemList = ret.data
        this.showList = this.itemList.slice(
          (this.p - 1) * this.limit,
          (this.p - 1) * this.limit + this.limit
        )
      }
    },
    handleSizeChange(val) {
      this.limit = val
      this.showList = this.itemList.slice(
        (this.p - 1) * this.limit,
        (this.p - 1) * this.limit + this.limit
      )
    },
    exportExcel() {
      const tHeader = [
        '订单编号',
        '订单状态',
        '套餐名称',
        '套餐详情',
        '签单人',
        '最后操作时间'
      ]
      const filterVal = [
        'order_id',
        'is_finish',
        'item_title',
        'detail',
        'editor_name',
        'modify_time'
      ]
      let list = JSON.stringify(this.itemList)
      list = JSON.parse(list)
      list.forEach(e => {
        e.is_finish =
          e.is_finish == 0 ? '进行中' : e.is_finish == 2 ? '已退款' : '已完成'
        e.detail = e.detail.map(item => {
          return item.text
        })
        e.detail = e.detail.join('，')
      })
      Tool.exportExcel(tHeader, filterVal, list, '订单信息')
    }
  }
}
</script>
<style lang="scss" scoped>
.order-details {
  .table-main {
    .table-header {
      padding: 30px 0;
      .el-button {
        width: 120px;
        height: 40px;
      }
    }
  }
}
</style>
